export const weatherAlerts = [
  { "type": "Tornado Warning", "category": "danger", "id": "tornado-warning", "priority": 1 },
  { "type": "Tornado Watch", "category": "info", "id": "tornado-watch", "priority": 2 },
  { "type": "Severe Thunderstorm Warning", "category": "danger", "id": "severe-thunderstorm-warning", "priority": 3 },
  { "type": "Severe Thunderstorm Watch", "category": "info", "id": "severe-thunderstorm-watch", "priority": 4 },
  { "type": "Flash Flood Warning", "category": "danger", "id": "flash-flood-warning", "priority": 5 },
  { "type": "Flash Flood Watch", "category": "info", "id": "flash-flood-watch", "priority": 6 },
  { "type": "Flood Warning", "category": "warning", "id": "flood-warning", "priority": 7 },
  { "type": "Flood Watch", "category": "info", "id": "flood-watch", "priority": 8 },
  { "type": "Hurricane Warning", "category": "danger", "id": "hurricane-warning", "priority": 9 },
  { "type": "Hurricane Watch", "category": "info", "id": "hurricane-watch", "priority": 10 },
  { "type": "Tropical Storm Warning", "category": "danger", "id": "tropical-storm-warning", "priority": 11 },
  { "type": "Tropical Storm Watch", "category": "info", "id": "tropical-storm-watch", "priority": 12 },
  { "type": "Winter Storm Warning", "category": "danger", "id": "winter-storm-warning", "priority": 13 },
  { "type": "Winter Weather Advisory", "category": "info", "id": "winter-weather-advisory", "priority": 14 },
  { "type": "Blizzard Warning", "category": "danger", "id": "blizzard-warning", "priority": 15 },
  { "type": "Ice Storm Warning", "category": "danger", "id": "ice-storm-warning", "priority": 16 },
  { "type": "Wind Chill Warning", "category": "danger", "id": "wind-chill-warning", "priority": 17 },
  { "type": "Wind Chill Advisory", "category": "info", "id": "wind-chill-advisory", "priority": 18 },
  { "type": "Excessive Heat Warning", "category": "danger", "id": "excessive-heat-warning", "priority": 19 },
  { "type": "Heat Advisory", "category": "warning", "id": "heat-advisory", "priority": 20 },
  { "type": "High Wind Warning", "category": "warning", "id": "high-wind-warning", "priority": 21 },
  { "type": "Wind Advisory", "category": "info", "id": "wind-advisory", "priority": 22 },
  { "type": "Red Flag Warning", "category": "warning", "id": "red-flag-warning", "priority": 23 },
  { "type": "Air Quality Alert", "category": "info", "id": "air-quality-alert", "priority": 24 },
  { "type": "Dust Storm Warning", "category": "danger", "id": "dust-storm-warning", "priority": 25 },
  { "type": "Dense Fog Advisory", "category": "info", "id": "dense-fog-advisory", "priority": 26 },
  { "type": "Frost Advisory", "category": "info", "id": "frost-advisory", "priority": 27 },
  { "type": "Freeze Warning", "category": "warning", "id": "freeze-warning", "priority": 28 },
  { "type": "Avalanche Warning", "category": "danger", "id": "avalanche-warning", "priority": 29 },
  { "type": "Avalanche Watch", "category": "warning", "id": "avalanche-watch", "priority": 30 },
  { "type": "Special Weather Statement", "category": "info", "id": "special-weather-statement", "priority": 31 },
  { "type": "Civil Emergency Message", "category": "danger", "id": "civil-emergency-message", "priority": 32 },
  { "type": "Fire Weather Watch", "category": "info", "id": "fire-weather-watch", "priority": 33 },
  { "type": "Coastal Flood Warning", "category": "danger", "id": "coastal-flood-warning", "priority": 34 },
  { "type": "Coastal Flood Advisory", "category": "warning", "id": "coastal-flood-advisory", "priority": 35 },
  { "type": "Storm Surge Warning", "category": "danger", "id": "storm-surge-warning", "priority": 36 },
  { "type": "Storm Surge Watch", "category": "warning", "id": "storm-surge-watch", "priority": 37 },
  { "type": "Gale Warning", "category": "warning", "id": "gale-warning", "priority": 38 },
  { "type": "Small Craft Advisory", "category": "info", "id": "small-craft-advisory", "priority": 39 },
  { "type": "Marine Weather Statement", "category": "info", "id": "marine-weather-statement", "priority": 40 },
  { "type": "Earthquake Warning", "category": "danger", "id": "earthquake-warning", "priority": 41 },
  { "type": "Volcano Warning", "category": "danger", "id": "volcano-warning", "priority": 42 },
  { "type": "Tsunami Warning", "category": "danger", "id": "tsunami-warning", "priority": 43 },
  { "type": "Tsunami Watch", "category": "warning", "id": "tsunami-watch", "priority": 44 }
];

// Helper function to get alert by type
export function getAlertByType(type) {
  return weatherAlerts.find(alert => alert.type.toLowerCase() === type.toLowerCase());
}

// Helper function to get alerts by category
export function getAlertsByCategory(category) {
  return weatherAlerts.filter(alert => alert.category === category);
}

// Helper function to get alert color based on category
export function getAlertColor(category) {
  const colors = {
    'danger': '#dc3545',   // Bootstrap danger red
    'warning': '#ffc107',  // Bootstrap warning yellow
    'info': '#17a2b8'      // Bootstrap info blue
  };
  return colors[category] || '#6c757d'; // Default gray
}

// Helper function to get Bootstrap class for alert
export function getAlertClass(category) {
  const classes = {
    'danger': 'alert-danger',
    'warning': 'alert-warning',
    'info': 'alert-info'
  };
  return classes[category] || 'alert-secondary';
}

// Helper function to sort alerts by priority
export function sortAlertsByPriority(alerts) {
  return alerts.sort((a, b) => {
    const alertA = getAlertByType(a.type || a.event);
    const alertB = getAlertByType(b.type || b.event);
    return (alertA?.priority || 999) - (alertB?.priority || 999);
  });
}

// Helper function to get icon for alert category
export function getAlertIcon(category) {
  const icons = {
    'danger': 'bi-exclamation-triangle-fill',
    'warning': 'bi-exclamation-circle-fill',
    'info': 'bi-info-circle-fill'
  };
  return icons[category] || 'bi-info-circle';
}

// Export categories for easy access
export const alertCategories = {
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info'
};